import { LoadingHandler } from './LoadingHandler';
import { App } from 'vue';

export default {
  install: (app: App, options?: unknown) => {
    app.config.globalProperties.$loading = new LoadingHandler(app, options);
  },
};
